module.exports = __webpack_public_path__ + "img/book-5.9bc4d955.png";